module.exports = __webpack_public_path__ + "static/media/jhu_wse.f42185be.png";